import { type Decoder, failure, success } from 'io-ts/Decoder';

/**
 * @see https://github.com/gcanti/io-ts/issues/8
 */
export const undefinedDecoder: Decoder<unknown, undefined> = {
	decode: (val: unknown) => {
		return val === undefined ? success(undefined) : failure(val, 'undefined');
	},
};
